import {createSelector} from "@ngrx/store";
import {appFeatureKey, AppState} from "./reducers";

export const message = createSelector(
  state => state[appFeatureKey],
  (state: AppState) => {
    return state.message
  }
);
